import { Flex, Space, Typography } from 'antd';
import { SymptomCard2Context } from 'features/patient/_components/symptom-card/symptom-card-2';
import { PatientInfoContext } from 'features/patient/_utils/patient-info/hook-context-patientinfo';
import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import { ConcussionComplexity } from 'lib/documents/concussion-complexity';
import moment from 'moment';
import { useContext } from 'react';
import { StyledConcussionComplexity } from '../../../patient-home/components/patient-home-clinician/components/styled-concussion-complexity';
import { ConcussionComplexityDiagramWrapper } from '../concussion-complexity-diagram';

const averageRecoveryTimes = {
  [ConcussionComplexity.Minimal]: '1-3 months',
  [ConcussionComplexity.Mild]: '3-6 months',
  [ConcussionComplexity.Moderate]: '6-9 months',
  [ConcussionComplexity.High]: '9-12 months',
  [ConcussionComplexity.Extreme]: '12-18 months'
};

export function DisplaySubtype() {
  const {
    patientInfo: { concussion }
  } = useContext(PatientInfoContext);

  return (
    <>
      <Flex vertical>
        <ConcussionComplexityDiagramWrapper concussion={concussion} />
      </Flex>
    </>
  );
}
export function DisplayConcussionComplexity(
  props: Partial<Pick<PatientInfoState, 'concussion'>>
) {
  const patientInfo = useContext(PatientInfoContext);
  return (
    <EvaluatedOn
      concussion={props.concussion ?? patientInfo.patientInfo.concussion}
    />
  );
}

function EvaluatedOn(props: { concussion: PatientInfoState['concussion'] }) {
  /**
   * 2025-04-14
   *
   * The "Show all scores" toggle in the your-concussion card should toggle the recovery time in the subtype card
   * https://trello.com/c/xQ0pHASb/394-task-show-all-scores-should-toggle-recovery-time
   */
  const { showNumbers } = useContext(SymptomCard2Context);
  const { concussion } = props;
  if (concussion === undefined) {
    return <h1>No concussion data is available</h1>;
  }
  return (
    <Flex
      vertical
      justify={'center'}
      align={'center'}
      style={{
        textAlign: 'center'
      }}
    >
      <Typography.Text style={{ color: '#767679', marginBottom: 5 }}>
        <small>
          Evaluated on{' '}
          {moment(concussion.evaluatedOn.toISOString()).format('MMM DD, YYYY')}
        </small>
      </Typography.Text>

      <StyledConcussionComplexity
        complexity={concussion.subtype}
        style={{ padding: '1rem' }}
      />
      <Space direction="vertical" size={0} style={{ marginTop: '1rem' }}>
        {showNumbers && (
          <>
            <Typography.Text
              style={{
                fontFamily: 'Comfortaa',
                fontWeight: 700,
                color: '#A366FC'
              }}
            >
              <b>Average recovery time:</b>
            </Typography.Text>
            <Typography.Text
              style={{
                fontWeight: 700,
                color: '#A366FC'
              }}
            >
              <b>{averageRecoveryTimes[concussion.subtype]}</b>
            </Typography.Text>
          </>
        )}
      </Space>
    </Flex>
  );
}
